import React from 'react';
import '../../style/BottomNavigation.scss';
import { NavLink } from 'react-router-dom';
import { FiHome, FiCalendar, FiUser } from 'react-icons/fi';
import { MdOutlinePayment } from "react-icons/md";
import { FaStoreAlt } from "react-icons/fa";

function BottomNavigation() {
    return (
        <nav className="bottom-nav">
            <ul className="bottom-nav__list">
                <li className="bottom-nav__item">
                    <NavLink
                        to="/"
                        className={({ isActive }) =>
                            `bottom-nav__link ${isActive ? 'bottom-nav__link--active' : ''}`
                        }
                    >
                        <FiHome />
                    </NavLink>
                </li>
                <li className="bottom-nav__item">
                    <NavLink
                        to="/calendar"
                        className={({ isActive }) =>
                            `bottom-nav__link ${isActive ? 'bottom-nav__link--active' : ''}`
                        }
                    >
                        <FiCalendar />
                    </NavLink>
                </li>
                <li className="bottom-nav__item">
                    <NavLink
                        to="/pricingTable"
                        className={({ isActive }) =>
                            `bottom-nav__link ${isActive ? 'bottom-nav__link--active' : ''}`
                        }
                    >
                        <MdOutlinePayment />
                    </NavLink>
                </li>
                <li className="bottom-nav__item">
                    <NavLink
                        to="/businessWall"
                        className={({ isActive }) =>
                            `bottom-nav__link ${isActive ? 'bottom-nav__link--active' : ''}`
                        }
                    >
                        <FaStoreAlt />
                    </NavLink>
                </li>
                <li className="bottom-nav__item">
                    <NavLink
                        to="/profile"
                        className={({ isActive }) =>
                            `bottom-nav__link ${isActive ? 'bottom-nav__link--active' : ''}`
                        }
                    >
                        <FiUser />
                    </NavLink>
                </li>
            </ul>
        </nav>
    );
}

export default BottomNavigation;
